import {
    Subject,
    Observable
} from 'rxjs';

export class ParsedCsvLine {
    // Properties.
    private unparsedData: string = null;
    private parsedData: string[] = null;

    // Constructor.
    public constructor(lineOfText: string) {
        this.unparsedData = lineOfText;
        this.parsedData = ParsedCsvLine.csvToArray(lineOfText);
    }

    // Getter methods.
    public get ParsedData(): string[] {
        return this.parsedData;
    }

    public get UnparsedData(): string {
        return this.unparsedData;
    }

    // Helper methods.
    // pharv - 2/15/22 - added to account for values in the CSV which contain commas
    // See https://stackoverflow.com/questions/8493195/how-can-i-parse-a-csv-string-with-javascript-which-contains-comma-in-data
    private static csvToArray(text) {
        let p = '', row = [''], ret = [row], i = 0, r = 0, s = !0, l;
        for (l of text) {
            if ('"' === l) {
                if (s && l === p) row[i] += l;
                s = !s;
            } else if (',' === l && s) l = row[++i] = '';
            else if ('\n' === l && s) {
                if ('\r' === p) row[i] = row[i].slice(0, -1);
                row = ret[++r] = [l = '']; i = 0;
            } else row[i] += l;
            p = l;
        }
        return ret[0];
    };
}

export class CsvFileLoader {
    // Properties.
    private readonly CSV_BYTE_ORDER_MARK_PATTERN = new RegExp('ï»¿');

    private file: File = null;
    private allTextLines: string[] = null;
    private parsedLinesOfText: ParsedCsvLine[] = null;

    //private internalPromise: Promise<ParsedCsvLine[]> = null;
    private fileLoadedSubject: FileLoadedSubject<ParsedCsvLine[]> = null;

    // Constructor.
    public constructor(fileParam: File) {
        this.file = fileParam;
    }

    // Methods.
    public loadCsvFile(delimiter = ','): Promise<ParsedCsvLine[]> {
        let filename: string = this.file.name;

        this.fileLoadedSubject = new FileLoadedSubject(filename);

        const reader: FileReader = new FileReader();
        reader.onloadend = this.onFileReaderLoadEnd;
        reader.readAsDataURL(this.file);

        /*
        this.internalPromise = 
        let promise
        */
        let result: Promise<ParsedCsvLine[]> = new Promise(this.fulfillFileParsedPromise);
        return result;
    }

    // Getter methods.
    public get RawLinesOfText(): string[] {
        return this.allTextLines;
    }

    public get ParsedLinesOfText(): ParsedCsvLine[] {
        return this.parsedLinesOfText;
    }

    // Helper methods.
    private fulfillFileParsedPromise = (resolve, reject): void => {
        let observable: Observable<ParsedCsvLine[]> = this.fileLoadedSubject.asObservable();
        observable.subscribe(parsedCsvLines => {
            console.log('The parsed CSV lines are ready.');

            if (parsedCsvLines != null) {
                resolve(parsedCsvLines);
            }
        });

        return;
    }

    private onFileReaderLoadEnd = (e: any): void =>
    {
        // The file read has read the file and returned a string that
        // contains a header and the file's contents encoded in base64.
        let fileBase64ReadResult: string = e.target.result;

        if ((fileBase64ReadResult !== undefined) &&
            (fileBase64ReadResult !== null) &&
            (fileBase64ReadResult.length > 0))
        {
            let fileParts = fileBase64ReadResult.split(',');

            if ((fileParts != null) && (fileParts.length == 2)) {
                let base64Content: string = fileParts[1];
                let fileText: string = atob(base64Content);

                this.allTextLines = fileText.replace(this.CSV_BYTE_ORDER_MARK_PATTERN, '').split(/\r\n|\n/);

                this.parsedLinesOfText = [];
                if ((this.allTextLines != null) && (this.allTextLines.length > 0)) {
                    for (let iLine: number = 0; iLine < this.allTextLines.length; iLine++) {
                        let lineOfText: string = this.allTextLines[iLine];
                        let parsedLineOfText: ParsedCsvLine = new ParsedCsvLine(lineOfText);

                        this.parsedLinesOfText.push(parsedLineOfText);
                    }
                }
            } // if
        } // if

        if (this.fileLoadedSubject != null) {
            this.fileLoadedSubject.next(this.parsedLinesOfText);
            this.fileLoadedSubject.complete();
        }        

        return;
    }
}

// Define internally used classes.
class FileLoadedSubject<T> extends Subject<T> {
    // Properties.
    private fileName: string;

    // Constructor.
    constructor(fileNameParam: string) {
        super();

        this.fileName = fileNameParam;

        return;
    }

    // Methods.
    public get FileName(): string {
        return (this.fileName);
    }
}


